<template>
  <div class="detailed">
    <div class="top-info">
      <div class="collection" @click="toCollection">
        <div v-if="dataP.collection == 1">
          <img src="../../static/img/collection-s.png" alt="">取消收藏
        </div>
        <div v-else>
          <img src="../../static/img/collection-k.png" alt="">收藏
        </div>
      </div>
      <div class="title">{{dataP.title}}</div>
      <div>
        <div class="info-item" v-for="(item,index) in arrInfo" :key="index">
          <span class="info-item-title">{{item[0]}}：</span>
          <span class="info-item-content" v-if="item[1] == 'type'">
            {{getTypeName(dataP[item[1]])}}
          </span>
          <span v-else class="info-item-content">{{dataP[item[1]]}}</span>
        </div>
      </div>
      <p class="abstract" v-html="dataP.desc">{{dataP.desc}}</p>
    </div>
    <div class="download">
      <div class="download-title">
        <img class="download-title-icon" src="../../static/img/enclosure.png" alt="">附件
      </div>
      <div class="no-download" v-if="dataP.files && dataP.files.length == 0">该文档暂无附件</div>
      <div v-else class="enclosure-item" v-for="(item,index) in dataP.files" :key="index">
        <div class="enclosure-item-icon" 
          :class="item.type == '1'?'color1':item.type == '2'?'color2':item.type == '3'?'color3':'color4'">
          <img v-if="item.type == '1'" src="../../static/img/ex.png" alt="">
          <img v-else-if="item.type == '2'" src="../../static/img/pdf.png" alt="">
          <img v-else-if="item.type == '3'" src="../../static/img/ppt.png" alt="">
          <img v-else src="../../static/img/word.png" alt="">
        </div>
        <div class="enclosure-item-content">
          {{item.filename}}
          <a :href="item.filepath" target="blank" @click.prevent="downloadF(item.filepath,item.filename)">
            <img src="../../static/img/download-r.png">
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="relevant">
      <div class="relevant-title">
        <img class="relevant-title-icon" src="../../static/img/relevant.png" alt="">相关文档
      </div>
      <div @click="toRelevant(item.id)" class="relevant-item" v-for="(item,index) in relevantArr" :key="index">
        <div class="relevant-item-title">{{item.title}}</div>
        <div class="info-item" v-for="(item1,index1) in arrInfo" :key="index1">
          <span class="info-item-title">{{item1[0]}}：</span>
          <span class="info-item-content" v-if="item[1] == 'type'">
            {{getTypeName(dataP[item[1]])}}
          </span>
          <span v-else class="info-item-content">{{dataP[item[1]]}}</span>
        </div>
      </div>
    </div> -->
    <div v-if="moreTips" class="more" @click="getMore">{{moreTips}}</div>
  </div>
</template>

<script>
import service from '../service/demoService'
import tool from '../../static/js/public.js'
export default {
  name:'detailed',
  data(){
    return {
      myCollection:[],
      typeArr:[],
      relevantP:{
        pageNo:1,
        pageSize:7,
      },
      moreTips:'',
      relevantArr:[
        // {
        //   id:'1',
        //   title:'2020年国家科学技术奖获奖名单',
        //   desc:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
        //   time:'2019-12-23',
        //   category:'科学研究',
        //   source:'中华人民共和国科学技术部',
        // },
        // {
        //   id:'2',
        //   title:'2020年国家科学技术奖获奖名单',
        //   desc:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
        //   time:'2019-12-23',
        //   category:'科学研究',
        //   source:'中华人民共和国科学技术部',
        // },
      ],
      arrInfo:[
        ['公布时间','date'],
        ['类别','type'],
        ['来源','source_name'],
      ],
      dataP:{
        // id:'1',
        // title:'2020年国家科学技术奖获奖名单',
        // desc:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
        // date:'2019-12-23',
        // type:'科学研究',
        // source_name:'中华人民共和国科学技术部',
        // collection:1,
        // files:[
        //   {
        //     fileName:'2009年-中联重科杯-华夏建设科学技术奖推荐授奖项目名单(公示).pdf',
        //     type:'2', //类型1为表格类型，2为pdf类型，3为ppt类型，4为word类型
        //     filepath:'',
        //   },
        //   {
        //     fileName:'2018年度何梁何利基金科学与技术奖获奖.docx',
        //     type:'4', //类型1为表格类型，2为pdf类型，3为ppt类型，4为word类型
        //     filepath:'',
        //   },
        // ]
      },
    }
  },
  watch: {
  },
  methods:{
    downloadF (src, fileName) {
      console.log(src,fileName);
      let x = new XMLHttpRequest();
      x.open("GET", src, true);
      x.responseType = 'blob';
      x.onload = function(e) {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a');
        a.href = url
        a.download = fileName
        a.click()
      }
      x.send();
    },
    getMyCollection(){
      // let data = {
      //   pageSize:'',
      //   pageNo:'',
      // }
      return Promise.resolve(
        service.getmycollection().then(res => {
        console.log(res);
        if(res.state == 0){
          this.myCollection = res.data.map(item => {
            return item.id
          });
          console.log(this.myCollection);
        }
      }).catch(err => {
        this.open('系统错误！','warning')
      })
      )
      // service.getmycollection().then(res => {
      //   console.log(res);
      //   if(res.state == 0){
      //     this.myCollection = res.data.map(item => {
      //       return item.id
      //     });
      //     console.log(this.myCollection);
      //     return Promise.resolve(this.myCollection);
      //   }
      // }).catch(err => {
      //   this.open('系统错误！','warning')
      // })
      
    },
    getAllType(){
      service.getalltype().then(res =>{
        console.log(res);
        this.typeArr = res;
      })
    },
    getTypeName(id){
      let name = '';
      this.typeArr.forEach(item => {
        if(item.id == id){
          name = item.name
        }
      })
      return name;
    },
    getMore(){
      this.relevantP.pageNo += 1;
      this.getrelevant();
    },
    getrelevant(){
      let id = this.$route.query.id;
      let data = this.relevantP;
      data.id = id
      service.getrelevant(data).then(res => {
        if(res.state == 0){
          if(res.data.total == 0){
            this.moreTips = '';
          }
          this.relevantArr = this.relevantArr.concat(res.data.list);
          if(res.data.list.length < data.pageSize){
            this.moreTips = '没有更多了'
          }else{
            this.moreTips = '点击加载更多...'
          }
        }
      }).catch(err => {
        this.open('系统错误！','warning')
      })
    },
    open(str, type) {
      this.$message({
        message: str,
        type: type,
        duration: 800
      });
    },
    toCollection(){
      this.dataP.collection = this.dataP.collection == 1?2:1;
      let data = {
        id:this.dataP.id,
        type:this.dataP.collection == 1?2:1,
      }
      service.collectionbyid(data).then(res => {

      }).catch(err => {
        this.open('系统错误！','warning')
      })
    },
    toRelevant(id){  //跳转到相关文档
      this.$router.push({path:'/detailed',query:{id:id}});
    },
    getData(){
      let id = this.$route.query.id;
      service.getdetailed(id).then(res => {
      if(res.state == 0){
          this.dataP = res.data;
          if(this.myCollection.indexOf(id) > -1){
            this.dataP.collection = 1;
          }else{
            this.dataP.collection = 2;
          }
        }
      }).catch(err => {
        this.open('系统错误！','warning')
      })
    }
  },
  created(){
    this.getMyCollection().then(res => {
      console.log(res);
      this.getData();
      // let id = this.$route.query.id;
      // service.getdetailed(id).then(res => {
      // if(res.state == 0){
      //     this.dataP = res.data;
      //     console.log(this.myCollection);
      //     if(this.myCollection.indexOf(id) > -1){
      //       this.dataP.collection = 1;
      //     }else{
      //       this.dataP.collection = 2;
      //     }
      //   }
      //   console.log(this.dataP);
      // }).catch(err => {
      //   this.open('系统错误！','warning')
      // })
    }).catch(err => {
      this.myCollection = [];
      this.getData();
    });
    this.getAllType();
    // let id = this.$route.query.id;
    // service.getdetailed(id).then(res => {
    //  if(res.state == 0){
    //     this.dataP = res.data;
    //     console.log(this.myCollection);
    //     if(this.myCollection.indexOf(id) > -1){
    //       this.dataP.collection = 1;
    //     }else{
    //       this.dataP.collection = 2;
    //     }
    //   }
    //   console.log(this.dataP);
    // }).catch(err => {
    //   this.open('系统错误！','warning')
    // })
    // this.getrelevant();
  },
  mounted(){
    
  },
}
</script>

<style lang="less">
@import '../../static/less/detailed.less';
</style>


// WEBPACK FOOTER //
// src/components/detailed.vue